import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingService } from './loading.service';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingService.enableShowSpinner();
    const token = localStorage.getItem('currentToken') ? localStorage.getItem('currentToken') : null;

    request = request.clone({
      headers: request.headers.set('APP', 'PORTAL RC')
    });

    if (token) {
      const reqClone = request.clone({
        headers: request.headers.set('X-Authorization', `Bearer ${token}`)
      });
      return next.handle(reqClone).pipe(
        finalize(() => {
          this.loadingService.disableShowSpinner();
          this.loadingService.disableShowPageSpinner();
        })
      );
    } else {
      return next.handle(request).pipe(
        finalize(() => {
          this.loadingService.disableShowSpinner();
          this.loadingService.disableShowPageSpinner();
        })
      );
    }
  }
}
